<template>
    <div class="panel panel-default">
        <div class="panel-heading" :class="{'panel-headingActive': isTarget}"
        @click="onFaqClick()">
            <h4 class="panel-title btn_angle_img_0">
                <a data-toggle="collapse" data-parent="#accordion" v-html="item.question">
                    
                </a>
                <span class="top_angle_img"></span>
                <img v-if="item.isHot" src="https://resource.rcclchina.com.cn/content/FAQ/hot_2.png">
            </h4>
        </div>
        <div class="panel-collapse" :style="itemStyle">
            <div class="panel-body" ref="itemBody">
                <p v-html="item.answer"></p>
                <div class="sort_about dn_0" v-if="item.url&&item.url.length>0">
                    <a target="_blank" :href="item.url">点击下载</a>
                </div>
                <faq-feedback 
                    :faq="item"
                    :selectedShipCategory="shipCategory"
                    :onFaqFeedbackSuccess="onFaqFeedbackSuccess"
                />
                
            </div>
        </div>
    </div>
</template>

<script>
const FaqFeedback = () => import('@/components/Faq/FaqFeedback')
export default {
    name: "FaqItem",
    components: {
        FaqFeedback
    },
    props: {
        isTarget: {
            type: Boolean,
            default () {
                return false
            }
        },
        item: {
            type: Object,
            default () {
                return {}
            }
        },
        shipCategory: {
            type: Object,
            default () {
                return {}
            }
        },
        onFaqFeedbackSuccess: {
            type: Function
        }
    },
    data () {
        return { 
            isOpen: false,
            itemHeight: 0
        }
    },
    methods: {
        onFaqClick () {
            this.$emit('faqClicked', this.item)
            if (this.item.openInNewWindow) {
                const urlLink =  "/Rccl.CustomPage/Faq/Detail/" + this.item.id + ".html?shipCategory=" + this.shipCategory.title
                    + "&shipSubCategory=" + this.shipCategory.subTitle;
                window.open(urlLink)
            } else {
                this.isOpen = !this.isOpen
            }
        },
    },
    computed: {
        itemStyle () {
            if (this.isOpen && !this.item.openInNewWindow) {
                const height = this.$refs.itemBody.clientHeight
                console.log(height)
                return { height: height + 'px', overflow: 'initial'}
            } else {
                return {}
            }
        }
    }
}
</script>


<style lang="less" scoped>
.panel{
  margin-bottom: 10px;
  cursor: pointer;
  position:relative;
}
.panel-default>.panel-heading{
  background-color: #fff;
}
.panel-default .panel-body span{
  font-size:14px !important;
}

.panel-headingActive{
  background-color: #dbdbdb !important;
}
.panel-heading{
  padding: 20px 15px;
}

/*top_angle_img*/
.top_angle_img{
  display: inline-block;
  width: 15px;
  height: 15px;
  float: right;
  background: url(https://resource.rcclchina.com.cn/content/FAQ/bottomimg1.png) 3px 8px no-repeat;
}
.btn_angle_img2{
  display: inline-block;
  width: 15px;
  height: 15px;
  float: right;
  background: url(https://resource.rcclchina.com.cn/content/FAQ/topimg1.png) 3px 8px no-repeat;
}

/**** 问答图片样式 ****/
.panel-collapse.collapse p>img{
    width:100%;
    height:auto;
}


.sort_about{
  width: 100px;
  height: 30px;
  border-radius: 5px;
  background: #fbc300;
  text-align: center;
  line-height: 30px;
  color: #333333;
  font-size: 13px;
  font-weight: 500;
  margin: 8px 0 0 0;
  cursor: pointer;
}
.sort_about a{
  color: #000;
  width: 100%;
  display: inline-block;
}

.panel-collapse {
    position:relative;
    height: 0px;
    overflow: hidden;
    transition: height 0.2s;
    &.in {
        overflow: initial;
    }
}

</style>

<style lang="less">
.panel-default>.panel-heading .panel-title p span{
  font-size:16px !important;
}
.panel-default>.panel-heading .panel-title p{
  display:inline;
}

</style>